import React from 'react';

import Layout from './components/Layout';
import TimeTrackReports from './timeTrackReport/timeTrackReport';
import Filters from './timeTrackReport/components/TimeTrackingFilterContainer';

const TimeTrackReport = () => (
  <Layout title="Time track">
    <Filters />
    <TimeTrackReports />
  </Layout>
);

export default TimeTrackReport;
